import { buildHourSlots, GRID_START_HOUR, GRID_END_HOUR } from './dateUtils'

export const CREW_MEMBERS = [
  { id: 'aaron-f', name: 'Aaron F' },
  { id: 'miguel-r', name: 'Miguel R' },
  { id: 'carlos-m', name: 'Carlos M' },
  { id: 'jose-l', name: 'Jose L' },
  { id: 'david-t', name: 'David T' },
  { id: 'marco-s', name: 'Marco S' },
  { id: 'luis-g', name: 'Luis G' },
  { id: 'chris-p', name: 'Chris P' },
]

// 5 AM → midnight (00:00). Midnight sorts at end of day, not start.
export const TIME_SLOTS = buildHourSlots(GRID_START_HOUR, GRID_END_HOUR)

export const JOB_STATUSES = [
  { value: 'scheduled', label: 'Scheduled' },
  { value: 'in_progress', label: 'In Progress' },
  { value: 'complete', label: 'Complete' },
  { value: 'cancelled', label: 'Cancelled' },
]

// Billing methods live on the property and auto-fill each job's schedule box.
export const BILLING_METHODS = [
  'None',
  'OPS',
  'Vendor Cafe',
  'Paymode',
  'Vendor Access',
  'Coupa',
  'Email',
]

export const STATUS_COLORS = {
  scheduled: {
    bg: 'bg-white',
    border: 'border-blue-400',
    text: 'text-gray-800',
    dot: 'bg-blue-500',
  },
  in_progress: {
    bg: 'bg-white',
    border: 'border-yellow-400',
    text: 'text-gray-800',
    dot: 'bg-yellow-500',
  },
  complete: {
    bg: 'bg-white',
    border: 'border-green-400',
    text: 'text-gray-800',
    dot: 'bg-green-500',
  },
  cancelled: {
    bg: 'bg-white',
    border: 'border-gray-300',
    text: 'text-gray-400',
    dot: 'bg-gray-400',
  },
}
